/**
 * Platform-staff invitations — admin CRUD.
 *
 * Email and the one-time link are owned by the identity realm; the backend
 * creates the user there and sends the actions email. Redemption is the
 * invitee's first sign-in — not a frontend endpoint.
 */
import { apiDelete, apiGet, apiPost } from '../client.js';
import type { PlatformStaffRole } from '../types.js';

export interface PlatformStaffInvitation {
  id: string;
  token: string;
  invited_role: PlatformStaffRole;
  invited_email: string;
  issued_by: string;
  expires_at: string;
  used_at: string | null;
  used_by_external_sub: string | null;
  used_by_idp: string | null;
  revoked_at: string | null;
  created_at: string;
}

export interface CreateInvitationBody {
  role: PlatformStaffRole;
  email: string;
  ttl_minutes?: number;
}

export function listPlatformStaffInvitations(): Promise<PlatformStaffInvitation[]> {
  return apiGet<PlatformStaffInvitation[]>('/api/v1/admin/platform-staff/invitations');
}

export function createPlatformStaffInvitation(
  body: CreateInvitationBody,
): Promise<PlatformStaffInvitation> {
  return apiPost<PlatformStaffInvitation>(
    '/api/v1/admin/platform-staff/invitations',
    body,
  );
}

export function revokePlatformStaffInvitation(token: string): Promise<void> {
  return apiDelete<void>(
    `/api/v1/admin/platform-staff/invitations/${encodeURIComponent(token)}`,
  );
}
